<template>
  <div>
    <van-nav-bar
      class="backBox"
      :title="'人脸采集'"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <FaceRecognition @resultImg="getResultImg"></FaceRecognition>

  </div>
</template>
<script>
import FaceRecognition from './FaceRecognition.vue'
import * as common from '../../api/common'
import * as api from '../../api/api'
import * as utils from '../../api/utils'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'

export default {
  components: {
    FaceRecognition
  },
  data () {
    return {
      form: {
        username: '',
        numID: '',
        face: '',
        uploader: []
      },
      img: ''
    }
  },
  mounted () {

  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    getResultImg (val) {
      console.log('拿到的人脸', val)
      this.img = val
    },
    collectionOK () {
      if (this.h5Config.funCfg.h5Type !== 3) {
        // 琴房、教室
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const imgFile = utils.base64ToBlob(this.img, 'face.jpeg')
        const para = {
          formData: true,
          files: imgFile,
          json: api.getPublicPara(false)

        }
        para.json.user_id = Number(userInfo.userid)

        api
          .axiosRequest(
            api.urlList.pianoBindFace,
            para,
            null,
            true
          )
          .then(res => {
            if (res.code === common.resCode.OK) {
              Toast.success('绑定人脸成功')

              this.$router.replace('/collectionFaceOK')
            } else {
              Toast.fail('绑定人脸失败', res.msg)
            }
          })
      } else if (this.h5Config.funCfg.h5Type === 3) {
        // 办公室

        const facePara = JSON.parse(sessionStorage.getItem('facePara'))

        const imgFile = utils.base64ToBlob(this.img, 'face.jpeg')

        const para = {
          formData: true,
          files: imgFile,
          json: {}
        }
        para.json.user_name = facePara.user_name
        para.json.account = facePara.account
        para.json.grade_id = facePara.grade_id
        para.json.class = facePara.class
        para.json.campus = facePara.campus
        para.json.department = facePara.department
        para.json.course_type = facePara.course_type

        api
          .axiosRequest(
            api.urlList.bindFace,
            para,
            null,
            true
          )
          .then(res => {
            if (res.code === common.resCode.OK) {
              this.$router.replace('/collectionFaceOK')
            } else {
              Toast.fail('新增员工失败', res.msg)
            }
          })
      }
    },
    addFace () {

    },
    confirm () {
      console.log(this.form)
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped>
</style>
